import { ref } from 'vue'

import { uiLabel } from '../utils/labels'

// A single dialog instance mounted by the shell (UiConfirmHost). Any component
// can await confirm() and get a boolean back, instead of every screen carrying
// its own modal and its own boolean.
const state = ref(null)

export function useConfirm() {
  /**
   * @returns {Promise<boolean>} true when the user confirms
   *
   *   if (await confirm({ title: 'Delete user', danger: true })) …
   *
   * The two buttons fall back to the shared wording the shell installed, so a
   * caller that only has something to say about the title does not have to
   * translate "Cancel" again.
   */
  function confirm({ title, message = '', confirmLabel, cancelLabel, danger = false }) {
    return new Promise(resolve => {
      state.value = {
        title,
        message,
        confirmLabel: confirmLabel ?? uiLabel('confirm'),
        cancelLabel: cancelLabel ?? uiLabel('cancel'),
        danger,
        resolve: (answer) => { state.value = null; resolve(answer) },
      }
    })
  }

  return { state, confirm }
}
